import type React from "react";
import {Alert, Stack} from "@mui/material";
import {useOutletContext} from "react-router";
import type {TaxonomyBuilderOutletContext} from "~/pages/taxonomy-builder-v2/types/TaxonomyBuilderTypes";
import {TaxonomyTreeView} from "./components/tree/TaxonomyTreeView";
import {TaxonomyTreeViewSkeleton} from "./components/tree/TaxonomyTreeViewSkeleton";
import {STICKY_HEADER_HEIGHT, TAB_CONTENT_HEIGHT} from "~/pages/taxonomy-builder-v2/constants/taxonomyBuilderLayout";

// Not in this version: the Table and Treemap views, and the switch between them and the tree.
// import {useEffect, useRef, useState} from "react";
// import {Button, Typography} from "@mui/material";
// import {Add} from "@mui/icons-material";
// import {SegmentedControl} from "~/components/segmented-control/SegmentedControl";
// import {TaxonomySearchField} from "~/pages/taxonomy-builder-v2/components/TaxonomySearchField";
// import {AllCategoriesTable} from "./components/AllCategoriesTable";
//
// const VIEW_MODES = ['Table', 'Tree', 'Treemap'] as const;

export const AllCategoriesTab: React.FC = () => {
    // Not in this version: the Table and Treemap views.
    // const [search, setSearch] = useState('');
    // const [mode, setMode] = useState<number>(0);
    // const view = VIEW_MODES[mode];

    const {taxonomyId, taxonomy, isLoading, isError} = useOutletContext<TaxonomyBuilderOutletContext>();

    // Not in this version: the view switch and the Table view's toolbar.
    // // The Tree view carries the switch in its canvas; until it can draw, the switch stays in the row.
    // const treeReady = view === 'Tree' && Boolean(taxonomy) && !isError;
    //
    // // Changing the view scrolls the tab up under the sticky header, so the whole canvas is on screen.
    // // Runs once the new view is drawn; not on the first render, so opening the page doesn't jump.
    // const contentRef = useRef<HTMLDivElement>(null);
    // const shownMode = useRef(mode);
    // useEffect(() => {
    //     if (shownMode.current === mode) return;
    //     shownMode.current = mode;
    //     contentRef.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
    // }, [mode]);
    // const viewSwitch = <SegmentedControl labels={[...VIEW_MODES]} value={mode} onChange={setMode}/>;

    const renderView = () => {
        if (!taxonomyId) return <Alert severity="info">This dataset has no taxonomy.</Alert>;
        if (isError) return <Alert severity="error">Could not load the taxonomy.</Alert>;
        if (isLoading || !taxonomy) return <TaxonomyTreeViewSkeleton/>;
        // Not in this version:
        // if (view === 'Table') return <AllCategoriesTable rows={[]} isLoading={isLoading} title="0 categories"/>;
        // if (view === 'Tree') return <TaxonomyTreeView taxonomy={taxonomy} toolbar={viewSwitch}/>;
        // return <Typography color="text.secondary">The treemap view isn't built yet.</Typography>;
        return <TaxonomyTreeView taxonomy={taxonomy}/>;
    };

    return (
        <Stack gap={2} sx={{height: TAB_CONTENT_HEIGHT, scrollMarginTop: STICKY_HEADER_HEIGHT}}>
            {/* Not in this version: the Table view's search and add, and the view switch. */}
            {/* {!treeReady && (
                <Stack direction="row" alignItems="center" gap={2}>
                    {view === 'Table' && <>
                        <TaxonomySearchField value={search} onChange={setSearch}/>
                        <Button variant="outlined" startIcon={<Add/>} disabled>Add category</Button>
                    </>}
                    {viewSwitch}
                </Stack>
            )} */}
            {renderView()}
        </Stack>
    );
};
